import React from 'react';

import Indicators  from 'components/Tvendo/Sale/QuotaBPartner/Arcor/Indicators/List.js';

export default function () {
  return <Indicators  />;
}